import { gql } from 'graphql-request'
import { MAX_ITEMS_PER_QUERY } from '../../api-parameters'



export const poolsQuery = gql`
    {
        pools(first: ${MAX_ITEMS_PER_QUERY}) {
            id
            controller
            publicSwap
            finalized
            totalSwapVolume
            totalShares
            liquidity
            tokens{
                id
                symbol
                name
                address
                denormWeight
                balance
                decimals
            }
            tokensList
            dailyActivity {
                id
                dailyFees
                dailyVolume
                swapCount
            }
            lpTokenPrices {
              id
              price
            }
            createTime
        }
    }
`

/**
 * Address pools must be lowercased
 */
export const userPools = gql`
  query ($poolAddress: String!, $userAddress: String!) {
    pool(id: $poolAddress) {
      id
      finalized
      liquidity
      tokens {
        id
        symbol
        denormWeight
        balance
      }
      shares(where: { userAddress: $userAddress }) {
        id
        balance
      }
    }
  }
`
